import React, { useEffect, useState } from "react";
import { Grid, Button, Dropdown, Segment, Message } from "semantic-ui-react";
import { toast } from "react-toastify";
import { config } from "../../contexts/UrlContext";
import axios from "axios";

type searchBarType = {
    filter: string,
    filterCallback: any,
    searchString: string,
    onSearchChange: any,
    onResultsCallback: any,
}

export const searchOptions = [
    { key: 0, text: 'Name', value: "name" },
    { key: 1, text: 'Description', value: "description" },
    { key: 2, text: 'Updated By', value: "updatedby" }
]

function SearchBar({ filter, filterCallback, searchString, onSearchChange, onResultsCallback }: searchBarType) {

    useEffect(() => {

    }, [])

    const handleKeyPress = (event: any) => {
        if (event.key === 'Enter') {
            searchFilteredResults(1);
        }
    }

    const onDropdownChange = (event: any, result: any) => {
        filterCallback(result.value);
    }

    const searchFilteredResults = (page: number) => {
      
        if (filter === "Name") // values are all in lowercase, default "Name" is search option  not chosen
        {
            toast.error("Please select a Search By filter");
            return;
        }

        if (searchString === null || searchString === "") {
            toast.error("Please provide a search string");
            return;
        }
        onResultsCallback(searchString, page);
    }

    const clearFilteredResults = (page: number) => {
        onSearchChange("");
        onResultsCallback("", page);
    }

    return (
        <Grid style={{ marginLeft: "10px", marginBottom: 10 }}>
            <Grid.Row>
                <Grid.Column width={2} style={{marginRight:'-25px'}}>
                    <div className="header gray headerStyleGray" style={{ marginLeft: '0px', marginTop:38 }}>Search By</div>
                </Grid.Column>
                <Grid.Column width={4} style={{marginLeft:'-40px'}}>
                    <Dropdown id="search-dropdown" placeholder='Search' style={{ backgroundColor: "#e5e5e5" , marginTop:29, width:'90%', marginleft:'-10px'}} fluid search selection options={searchOptions} onChange={onDropdownChange} value={filter} />
                </Grid.Column>
                <Grid.Column width={10} style={{marginLeft:'-20px'}}>
                    <div className="ui input fluid" style={{ marginTop: '29px' }} >
                        <input id="search-bar" type="text" placeholder="Search Tables..." style={{backgroundColor: "#e5e5e5" }} value={searchString} onChange={(e) => { onSearchChange(e.target.value) }} onKeyDown={handleKeyPress} />
                        <Button id="search-button" className='buttton' style={{ cursor: 'pointer', marginLeft: '10px' }} onClick={() => searchFilteredResults(1)} >Search</Button>
                        <Button id="clear-button" className='buttton' style={{ cursor: 'pointer', marginLeft: '10px', marginRight:'-95px' }} onClick={() => clearFilteredResults(1)} >Clear</Button>
                    </div>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    )
}

export default SearchBar;
